export default __webpack_public_path__ + "static/media/packaging_template.d3238025.png";